export { BEE_FORM_ITEM_DEFAULT_APPEARANCE } from './bee-form-item-default-appearance';
